import type { TaskBlock, TextBlock } from '@/entities/chat-message';
import { InsightCard } from './InsightCard';

function TimelineDot() {
  return (
    <div className="relative z-10 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-gray-100">
      <div className="h-1.5 w-1.5 rounded-full bg-gray-400" />
    </div>
  );
}

export interface InsightGroup {
  heading: TextBlock | null;
  cards: TaskBlock[];
}

interface InsightsGroupProps {
  group: InsightGroup;
}

export function InsightsGroup({ group }: InsightsGroupProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-start gap-3">
        <TimelineDot />
        {group.heading && (
          <p className="text-[13px] text-gray-500 italic">
            {group.heading.data}
          </p>
        )}
      </div>
      {group.cards.length > 0 && (
        <div className="ml-8 flex flex-col gap-2">
          {group.cards.map((card, idx) => (
            <InsightCard key={card.key ?? idx} block={card} />
          ))}
        </div>
      )}
    </div>
  );
}
